import { Checkbox, type CheckboxRootProps, LuIcon, stopPropagation } from "@overmap-ai/blocks"
import { memo } from "react"

import { modelIconMapping } from "../../../mappings/icons"

interface RowSelectAllCheckboxProps extends Omit<CheckboxRootProps, "checked" | "onCheckedChange" | "children"> {
	toggleAllRowsSelected: (value: boolean) => void
	isSomeRowsSelected: boolean
	isAllRowsSelected: boolean
}

export const RowSelectAllCheckbox = memo<RowSelectAllCheckboxProps>((props) => {
	const { toggleAllRowsSelected, isSomeRowsSelected, isAllRowsSelected, size = "sm", ...rest } = props

	const checked = isAllRowsSelected ? true : isSomeRowsSelected ? "indeterminate" : false

	return (
		<Checkbox.Root
			checked={checked}
			onCheckedChange={toggleAllRowsSelected}
			aria-label="Select all rows"
			size={size}
			onClick={stopPropagation}
			{...rest}
		>
			<Checkbox.Indicator>
				<LuIcon icon={modelIconMapping.check} />
			</Checkbox.Indicator>
		</Checkbox.Root>
	)
})
RowSelectAllCheckbox.displayName = "RowSelectAllCheckbox"
